import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectBloodType = ({ selectedBloodType, onChange, getData, disabled }) => {
  const { translate: t } = useDictionaryTranslation();
  const [bloodTypes, setBloodTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectBloodType = (item) => {
    const bloodType = bloodTypes.find((bt) => bt.description === item.value);
    onChange(bloodType);
  };

  const getBloodTypes = useCallback(
    async (search) => {
      setLoading(true);
      try {
        const params = { search, isServiceCreation: true };
        const { bloodTypes: bloodTypesList } = await getData(params);
        setBloodTypes(bloodTypesList);
      } catch (error) {
        setBloodTypes([]);
      } finally {
        setLoading(false);
      }
    },
    [getData],
  );

  const getOptionData = useCallback((bloodType) => {
    return {
      value: bloodType.description,
      label: bloodType.description,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t('bloodTypePlaceholder')}
      isLoading={loading}
      onChange={selectBloodType}
      options={bloodTypes}
      value={selectedBloodType}
      onSearch={getBloodTypes}
      getOptionData={getOptionData}
      disabled={disabled}
    />
  );
};

SelectBloodType.propTypes = {
  selectedBloodType: PropTypes.shape({
    description: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  getData: PropTypes.func,
  disabled: PropTypes.bool,
};

SelectBloodType.defaultProps = {
  getData: InteroperableDataService.getBloodTypes,
};
